import { useWSStore } from "../../store";

// v3-migration (contractor-details, user-confirmed 2026-07-22): org-expansion
// scope used to be gated by the v1 experiments flag
// `enableContractorOrgExpansion` (a `useFeatureFlags` read against the v1
// experiments service, which has no v3 twin). To take the contractor-details
// screen — and every other consumer of this hook — off v1, the flag gate is
// dropped and the scope is read straight from client state
// (`store.xWingspanExpansion`), which is only ever populated once org-expansion
// is entered. This collapses the hook onto the behavior of the previously
// separate `useNonContractorXWingspanExpansion`. See V3_MIGRATION_TRACKER.md.
export const useXWingspanExpansion = () => {
  const store = useWSStore();

  return store.xWingspanExpansion;
};

// Retained as an explicit alias for call sites that already opted out of the
// flag gate; now identical to `useXWingspanExpansion`.
export const useNonContractorXWingspanExpansion = () => {
  const store = useWSStore();

  return store.xWingspanExpansion;
};
